import { put, call, takeEvery, select } from 'typed-redux-saga/macro';

import { SagaWatcherReturnType } from 'sagas/types';
import OutletGateway from 'api/Outlet';
import CombinedActions from 'redux/CombinedActions';
import { GatewayResponseStatus } from 'api/types/types';
import CombinedSelectors from 'redux/CombinedSelectors';

import Utils from 'lib/Utils';
import NavActions from 'lib/NavActions';

export default function* watchGetOutletListing(api: OutletGateway): SagaWatcherReturnType {
    yield takeEvery('outlet/outletGetOutletListingAttempt', handleGetOutletListing, api);
}

function* handleGetOutletListing(api: OutletGateway) {
    const { Auth: { getAuthToken } } = Utils;

    const { navResetToLogin } = NavActions;

    let authToken = yield* select(CombinedSelectors.auth.getAuthToken);

    if (!authToken) authToken = getAuthToken() || '';

    if (!authToken) {
        yield put(CombinedActions.outletGetOutletListingFailure('Something went wrong. Please try again later'));
        navResetToLogin();
        return;
    }

    const response = yield* call([api, api.getOutletListing], { authToken });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(CombinedActions.outletGetOutletListingFailure(response.message));
        return;
    } if (response.status === GatewayResponseStatus.Success) {
        if (response.data) {
            yield put(CombinedActions.outletGetOutletListingSuccess(response.data));
            return;
        }

        yield put(CombinedActions.outletGetOutletListingFailure('Something went wrong. Please try again later'));
    }
}
